import clsx from "clsx";
import AutoSubmit from "components/Forms/AutoSubmit.tsx";
import { Form, Formik, useField } from "formik";
import type { AssetTypeEnum } from "kubb";
import { type Cursor, useGetAssetListAssetGet } from "kubb";
import { useState } from "react";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent.tsx";
import ApiPaginatedTable from "../../../components/Pagination/NewApiPaginatedTable";
import { Button } from "../../../components/Theme/button";
import {
  TableCell,
  TableHeader,
  TableRow,
} from "../../../components/Theme/table";
import type { Asset } from "../../../utils/object.tsx";

export default function AssetSelectFormField(props: {
  name: string;
  assetType: AssetTypeEnum[];
  company_id: string;
  unassignedOnly?: boolean;
  queryKey?: string[];
}) {
  const [field, _meta, { setValue }] = useField(props.name);
  const defaultCursor: Cursor = { max_items: 10 };
  const { unassignedOnly = true } = props;
  const [cursor, setCursor] = useState<Cursor>(defaultCursor);
  const [filter, setFilter] = useState<string>();

  const { data, isPending, error } = useGetAssetListAssetGet(
    {
      company_id: props.company_id,
      asset_type: props.assetType,
      asset_position_id: unassignedOnly ? "NONE" : undefined,
      text_search: filter,
      exclude_retired: true,
      ...cursor,
    },
    { query: props.queryKey ? { queryKey: props.queryKey } : undefined },
  );

  return (
    <>
      <Formik
        initialValues={{ serial_number: "" }}
        onSubmit={(v) => {
          setFilter(v.serial_number !== "" ? v.serial_number : undefined);
          setCursor(defaultCursor);
        }}
      >
        {() => (
          <Form action={""}>
            <AutoSubmit ignoreDirty={true} />
            <NewTextFormComponent
              fieldName={"serial_number"}
              label={{ label: "Filter", size: "sm" }}
            />
          </Form>
        )}
      </Formik>

      <ApiPaginatedTable
        data-cy={"asset-select"}
        loading={isPending}
        error={error}
        data={{
          data: data?.data || [],
          cursor: data?.headers["x-cursor"] || { max_items: 10 },
          setCursor: (c) => {
            if (c) setCursor(c);
          },
        }}
        header={[
          <TableRow key={1}>
            <TableHeader>Serial Number</TableHeader>
            <TableHeader>Manufacturer</TableHeader>
            <TableHeader>&nbsp;</TableHeader>
          </TableRow>,
          3,
        ]}
        row={(asset: Asset, _) => (
          <TableRow
            key={asset.asset_id}
            className={clsx(
              field.value === asset.asset_id && "bg-brand-light-200",
            )}
          >
            <TableCell>{asset.serial_number}</TableCell>
            <TableCell>{asset.manufacturer}</TableCell>
            <TableCell>
              <Button
                color={"brandLight"}
                onClick={() => setValue(asset.asset_id)}
                size={"sm"}
              >
                Select
              </Button>
            </TableCell>
          </TableRow>
        )}
      />
    </>
  );
}
